module.exports = __webpack_public_path__ + "static/media/bearing.37bec35a.jpg";